import React, { useState } from "react";
import { MessageCircle, Copy, Share2 } from "lucide-react";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { isoToDisplay } from "./DateInput";
import { salinTeks } from "../pages/UlangTahunPage";
import { toast } from "sonner";

// Ringkasan jadwal satu minggu → teks WhatsApp (salin / buka WA untuk dikirim ke grup pelayan).
export const ringkasanJadwal = (minggu, posisi) => {
  const isi = minggu.isi || {};
  const baris = posisi.filter((p) => (isi[p] || "").trim()).map((p) => `• *${p}*: ${isi[p].trim()}`);
  return [`*JADWAL PELAYANAN*`, `Minggu, ${isoToDisplay(minggu.tanggal)}`, "", ...(baris.length ? baris : ["(belum diisi)"]), "", "Tuhan Yesus memberkati pelayanan kita 🙏"].join("\n");
};

export const KirimJadwalWA = ({ minggu, posisi, testId }) => {
  const [buka, setBuka] = useState(false);
  const teks = ringkasanJadwal(minggu, posisi);
  const salin = async () => { if (await salinTeks(teks)) toast.success("Ringkasan jadwal disalin — tempel di grup WhatsApp pelayan"); else toast.error("Gagal menyalin"); };
  return (
    <>
      <Button type="button" size="sm" variant="outline" className="h-7 rounded-lg text-[11px] text-emerald-700 border-emerald-300 hover:bg-emerald-50 px-2" onClick={() => setBuka(true)} title="Kirim ringkasan jadwal via WhatsApp" data-testid={testId}><MessageCircle className="h-3.5 w-3.5 mr-1" /> WA</Button>
      <Dialog open={buka} onOpenChange={setBuka}>
        <DialogContent className="rounded-2xl max-w-lg" data-testid={`${testId}-dialog`}>
          <DialogHeader><DialogTitle>Kirim Jadwal via WhatsApp</DialogTitle><DialogDescription>Minggu, {isoToDisplay(minggu.tanggal)} — salin lalu tempel di grup pelayan, atau buka WhatsApp dan pilih grup tujuan.</DialogDescription></DialogHeader>
          <pre className="whitespace-pre-wrap font-sans text-sm text-slate-800 bg-slate-50 rounded-xl p-4 border border-slate-100 max-h-[45vh] overflow-y-auto" data-testid={`${testId}-teks`}>{teks}</pre>
          <DialogFooter className="gap-2 sm:gap-0">
            <Button variant="outline" className="rounded-xl min-h-[44px]" onClick={salin} data-testid={`${testId}-salin`}><Copy className="h-4 w-4 mr-2" /> Salin Teks</Button>
            <Button asChild className="rounded-xl min-h-[44px] bg-emerald-600 hover:bg-emerald-700"><a href={`https://wa.me/?text=${encodeURIComponent(teks)}`} target="_blank" rel="noreferrer" data-testid={`${testId}-buka`}><Share2 className="h-4 w-4 mr-2" /> Buka WhatsApp</a></Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
